import React, { Component } from 'react';
import { connect } from 'react-redux';
import ContractSearchGrid from "./ContractSearchGrid";
import moment from 'moment'
import ContractSearchForm from "./Search";
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import * as ContractSearch from './Saga/ContractSearch';
interface Props {
    // customerNewDispSet: any,
    // customerNewDisp:number,
    // customerno:number,
    // customerList:any,
    // toggle:any,
    // get_rent_contract_accounting:any,
    get_rent_contracts: any,
    search_detail: any,
}



interface State {

    // state types
}

class CustomerList extends Component<Props, State> {
    componentWillMount() {
        // this.props.get_rent_contracts()
        // this.props.customerNewDispSet(0)
        this.submit = this.submit.bind(this);
    }
    //     aa(state:any){
    // console.log(state)
    //     }

    submit(state: any) {
        console.log(state)

        this.props.get_rent_contracts(state)
    }

    csv() {

        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }
    render() {

        return (
            <div className="row" >
                <div className="item-outer col-lg-12"
                //  style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    {this.props.search_detail.contractor}   {this.props.search_detail.tatemono_name + this.props.search_detail.room_name}　 {moment(this.props.search_detail.start_at).format("YYYY/MM/DD")}～{moment(this.props.search_detail.end_at).format("YYYY/MM/DD")}
                    {this.props.search_detail.corse}
                    <div className="item">
                        <ContractSearchForm />

                    </div>

                </div>

                {/* <div className="item-outer col-lg-12" style={{ display: (this.props.customerNewDisp === 1) ? '' : 'none' }}>
                    <div className="item">
           
                    </div>
                </div> */}


                <div className="item-outer col-lg-12"
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="item">
                        <ContractSearchGrid />
                    </div>
                </div>
            </div>
        );
    }
};


//export  default CustomerList;
const mapStateToProps = (state: any) => {
    return {
        // customerNewDisp: state.customersReducer.customerNewDisp,
        // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
        search_detail: state.kyousaiReducer.search_detail,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        // customerList(search:any) {
        //     dispatch(customerList(search))
        // },
        // customerNewDispSet(state:number) {
        //     dispatch(customerNewDispSet(state))
        // },
        // get_rent_contract_accounting(state:any) {
        //     dispatch(Monies.get_rent_contract_accounting(state))
        // },
        get_rent_contracts(state: any) {
            dispatch(ContractSearch.get_rent_contracts(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);




